
export const gaSendNavigationEvent = (eventLabel: string) => {
  gtag("event", "navigation-click", {
    event_category: "Navigation",
    event_label: eventLabel
  })
}

export const gaSendDashboardEvent = (eventLabel: string) => {
  gtag("event", "dashboard-click", {
    event_category: "Dashboard",
    event_label: eventLabel
  })
}

export const gaSendImportEvent = () => {
  gtag("event", "import", {
    event_category: "Dashboard",
    event_label: "Import success"
  })
}

export const gaSendClimateAdviceEvent = (eventLabel: string) => {
  gtag("event", "climate-advice", {
    event_category: "Climate advice",
    event_label: eventLabel
  })
}

export const gaSendClimateReportEvent = (eventLabel: string) => {
  gtag("event", "climate-report", {
    event_category: "Climate report",
    event_label: eventLabel
  })
}

export const gaSendLoginEvent = () => {
  gtag("event", "login")
}